const wizardComponentsHelper = require('../utilities/wizardComponenstHelper');
const inputs = require('./inputs');

const selfEmployed = require('./fioc/tarjetaCredito/tcSelfEmployed');
const employed = require('./fioc/tarjetaCredito/tcEmployed');
const rentier = require('./fioc/tarjetaCredito/tcRentier');
const pensioner = require('./fioc/tarjetaCredito/tcPensioner');
const withoutActivity = require('./fioc/tarjetaCredito/tcWithoutActivity');

function buildFioc(prefix = '', authorized = false) {
    const inputsFioc = wizardComponentsHelper.replacePrefix(inputs.fioc, prefix);
    inputsFioc.ocupation.prefix = prefix;
    return {
        id_component: 'fioc',
        id: prefix + 'tab-form-datos-personales',
        exclude: [],
        grid: [
            [inputsFioc.ocupation],
            [selfEmployed(prefix, authorized)],
            [employed(prefix, authorized)],
            [rentier(prefix, authorized)],
            [pensioner(prefix, authorized)],
            [withoutActivity(prefix, authorized)]
        ]
    };
}

module.exports = buildFioc;